import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import TwitterLogin from '@failbetter/react-twitter-auth';

import { twitterLogin, twitterLoginFailure } from 'actions/user';

import Config from 'configuration';

import redirectAfterLogin from './redirectAfterLogin';

export class TwitterLoginContainer extends Component {
  handleFailure = (error) => {
    const { dispatch } = this.props;
    if (error.toString() !== 'Error: Popup has been closed by user') {
      dispatch(twitterLoginFailure());
    }
  }

  handleSuccess = async (res) => {
    const { dispatch, history } = this.props;
    // Parse the response as JSON (the component is using native fetch, so doesn't do this for us)
    const body = await res.json();
    // Update the redux store
    const data = await dispatch(twitterLogin(body));

    // TODO: this is an error state; we are notifying Airbrake, but we should
    // let the user know that something's gone wrong
    if (!data) {
      return;
    }

    redirectAfterLogin(history, data);
  }

  render = () => {
    const { label } = this.props;
    const { apiUrl } = Config;
    return (
      <TwitterLogin
        loginUrl={`${apiUrl}twitter/login`}
        className="button button--big-blue-bird-from-san-francisco"
        text={label}
        onFailure={this.handleFailure}
        onSuccess={this.handleSuccess}
        requestTokenUrl={`${apiUrl}twitter/requesttoken`}
        credentials="include"
        showIcon
      />
    );
  }
}

TwitterLoginContainer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
};

export default withRouter(connect()(TwitterLoginContainer));